import { registerLookup } from "@redriver/cinnamon";
import { getGroups, getSites } from "./actions";

export const groupsLookup = registerLookup("groupsLookup", getGroups, {
  transform: (data) => data.map((x) => ({ value: x.id, text: x.name })),
  cache: false,
});

export const sitesLookup = registerLookup("sitesLookup", getSites, {
  transform: (data) => data.map((x) => ({ value: x.id, text: x.name })),
  cache: false,
});
